import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { doc, collection, getDoc } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";

export default function WhatsappFloatButton() {
    const [telefone, setTelefone] = useState("");

    useEffect(() => {
        const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
        getDoc(revendaRef).then((docSnap) => {
            if (docSnap.exists()) {
                setTelefone(retiraMascara(docSnap.data().petelefone2, "link"));
            }
        });
    }, []);

    if (!telefone) return null;

    return (
        <a
            href={`https://api.whatsapp.com/send?phone=55${telefone}`}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed z-50 bottom-4 right-4 md:bottom-6 md:right-6 bg-red-600 hover:bg-red-700 text-white rounded-full border border-white/20 shadow-lg p-3 md:p-4 flex items-center justify-center hover:scale-105 transition-all"
            aria-label="Fale conosco no WhatsApp"
            style={{ boxShadow: "0 8px 28px rgba(127,0,0,0.4)" }}
        >
            <FaWhatsapp className="text-2xl md:text-3xl" />
        </a>
    );
}
